const lightPalette = {
  greyTheme: {
    palette: {
      primary: {
        light: '#cfd8dc',
        main: '#607d8b',
        dark: '#37474f',
        contrastText: '#fff',
      },
      secondary: {
        light: '#bdbdbd',
        main: '#424242',
        dark: '#212121',
        contrastText: '#fff',
      },
    },
  },
  lightBlueTheme: {
    palette: {
      primary: {
        light: '#b3e5fc',
        main: '#03a9f4',
        dark: '#0277bd',
        contrastText: '#fff',
      },
      secondary: {
        light: '#80deea',
        main: '#00bcd4',
        dark: '#00838f',
        contrastText: '#fff',
      },
    },
  }
};

export default lightPalette;
